<template>
  <!-- 动态绑定 class，根据 props 自动生成对应的样式类 -->
  <view class="m-tag" :class="tagClass">
    {{ text }}
  </view>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  // 标签文本
  text: {
    type: String,
    default: ''
  },
  // 标签类型（主题颜色）
  type: {
    type: String,
    default: 'default', // default, primary, info, warning, danger, success
    validator: (val) => ['default', 'primary', 'info', 'warning', 'danger', 'success'].includes(val)
  },
  // 标签尺寸
  size: {
    type: String,
    default: 'medium', // sm, medium, large
    validator: (val) => ['sm', 'medium', 'large'].includes(val)
  },
  // 是否为胶囊圆角
  pill: {
    type: Boolean,
    default: false
  }
});

// 计算动态 class
const tagClass = computed(() => {
  return [
    `m-tag-${props.type}`,
    `m-tag-${props.size}`,
    { 'm-tag-pill': props.pill }
  ];
});
</script>

<style scoped>
/* 基础样式 */
.m-tag {
  display: inline-block;
  white-space: nowrap;
  border: 1px solid var(--glass-border);
  box-sizing: border-box;
  /* 默认 medium 尺寸 */
  padding: 2px 9px;
  font-size: 11px;
  line-height: 1.6;
  border-radius: 6px;
  background: var(--glass-bg);
  color: var(--text-primary);
}

/* 尺寸变体 */
.m-tag-sm {
  padding: 1px 6px;
  font-size: 10px;
  line-height: 1.5;
}

.m-tag-large {
  padding: 4px 12px;
  font-size: 13px;
  line-height: 1.6;
}

/* 胶囊圆角 */
.m-tag-pill {
  border-radius: 999px;
}

/* 颜色主题 */
.m-tag-primary { color: var(--accent); background: var(--primary-bg); border-color: var(--primary-border); }
.m-tag-info { color: var(--info); background: var(--info-bg); border-color: var(--info-border); }
.m-tag-warning { color: var(--warning); background: var(--warning-bg); border-color: var(--warning-border); }
.m-tag-danger { color: var(--danger); background: var(--danger-bg); border-color: var(--danger-border); }
.m-tag-success { color: var(--success); background: var(--success-bg); border-color: var(--success-border); }
</style>